import { render } from "./icon-file.vue?vue&type=template&id=58df479a"
import script from "./icon-file.vue?vue&type=script&lang=js"
export * from "./icon-file.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_dev\\engenious-pl\\public-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__